"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mouse = void 0;

var _react = require("react");

var Matter = _interopRequireWildcard(require("matter-js"));

var _World = require("./World");

var _Renderer = require("../Renderer");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var eventNames = ['mousedown', 'mousemove', 'enddrag', 'mouseup'];

var Mouse = function Mouse(_ref) {
  var _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events;
  var renderer = (0, _Renderer.useRenderer)();
  var engine = (0, _World.useEngine)();
  var mouseConstraint = (0, _react.useMemo)(function () {
    var mouse = Matter.Mouse.create(renderer.view);
    engine.render && (engine.render.mouse = mouse); // eslint-disable-line @typescript-eslint/no-explicit-any

    var constraint = {
      stiffness: 0.2,
      render: {
        visible: false
      }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any

    return Matter.MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: constraint
    });
  }, []);
  (0, _react.useEffect)(function () {
    Matter.World.add(engine.world, mouseConstraint.constraint);
    return function () {
      Matter.World.remove(engine.world, mouseConstraint.constraint);
    };
  }, [engine]);
  eventNames.forEach(function (name) {
    return (0, _react.useEffect)(function () {
      var callback = events[name];
      if (callback == null) return;
      Matter.Events.on(mouseConstraint, name, callback);
      return function () {
        return Matter.Events.off(mouseConstraint, name, callback);
      };
    }, [events[name]]);
  });
  return null;
};

exports.Mouse = Mouse;